import {rawHttp} from '../../services/http';
import {
    getAppointmentQuestionnaireEntryEndpoint,
    getConfirmDraftPrescriptionFilledEndpoint,
    getOccupationalMedicineDataEndpoint,
    getOccupationalMedicineDocumentPreviewEndpoint,
    getOccupationalMedicineStateEndpoint,
    getSendQuestionEndpoint,
} from './appointmentsEndpoints';
import {
    OccupationalMedicineData,
    OMPreviewDocumentType,
    QuestionnaireDto,
} from '../../types/appointments';

class AppointmentsApi {
    getOccupationalMedicineState(appointmentId: string) {
        return rawHttp.get<{filledByPatient: boolean}>(
            getOccupationalMedicineStateEndpoint(appointmentId),
        );
    }

    getOccupationalMedicineData(appointmentId: string) {
        return rawHttp.get<OccupationalMedicineData>(
            getOccupationalMedicineDataEndpoint(appointmentId),
        );
    }

    getOccupationalMedicineDocumentPreview(
        id: number,
        documentType: OMPreviewDocumentType,
    ) {
        return rawHttp.get(getOccupationalMedicineDocumentPreviewEndpoint(id), {
            params: {documentType},
            responseType: 'arraybuffer',
        });
    }

    getQuestionnaireEntry(appointmentId: string) {
        return rawHttp.get<QuestionnaireDto>(
            getAppointmentQuestionnaireEntryEndpoint(appointmentId),
        );
    }

    confirmDraftPrescriptionFilled(appointmentId: number, prescriptionDraftId: string) {
        return rawHttp.put(getConfirmDraftPrescriptionFilledEndpoint(appointmentId), {id: prescriptionDraftId});
    }

    sendQuestion(appointmentId: number, question: string) {
        return rawHttp.post(getSendQuestionEndpoint(appointmentId), {text: question});
    }
}

export const appointmentsApi = new AppointmentsApi();
